<!--
 * @Author: your name
 * @Date: 2022-04-19 15:45:49
 * @LastEditTime: 2022-04-29 13:24:26
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/mall/index.vue
-->
<template>
  <div class="order">
    <div class="head" @click="showCheckadd">
      <div class="head_img">
        <img src="../../static/image/positions.png" alt="" />
      </div>
      <div class="head_con" v-if="checkADD.id">
        <p class="con_address">{{ checkADD.addressDesc }}</p>
        <p class="con_name">
          {{ checkADD.contactName }} {{ checkADD.contactPhone }}
        </p>
      </div>
      <div class="set_con" v-if="!checkADD.id">
        填写收货信息
      </div>
      <div class="head_href">
        <img src="../../static/image/left.png" alt="" />
      </div>
    </div>
    <div class="goods_list">
      <div class="list_title">
        商品信息
      </div>
      <div class="list_item" v-for="(item, index) in list" :key="index">
        <div class="item_img">
          <img
            :src="item.imgUrl ? item.imgUrl : '../../static/image/bgimg.png'"
          />
        </div>
        <div class="item_center">
          <p class="center_tit">{{ item.name }}</p>
          <p class="center_price">
            ￥{{ item.normalPrice
            }}<span>x{{ (item.cartInfo && item.cartInfo.number) || 0 }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="distribution">
      <p class="distribution_tit">配送费</p>
      <p class="distribution_content">￥{{ saleTempInfo.deliveryCost }}</p>
    </div>
    <div class="distribution">
      <p class="distribution_tit">配送规则</p>
      <p class="distribution_content">{{ saleTempInfo.deliveryDesc }}</p>
    </div>
    <div style="padding-bottom:100px"></div>
    <div class="footers">
      <div class="car">
        <p class="totle">
          合计
          <span class="totle_money">￥{{ totleMoney }}</span>
        </p>
      </div>

      <div class="jiesuan" @click="showCheckPay = true">
        确认支付
      </div>
      <!-- <div class="car_send">
        还差13元起送
      </div> -->
    </div>
    <!-- 蒙版 收货地址 -->
    <div
      class="mask"
      v-if="showAddress || showCheckPay"
      @click="hidemask"
    ></div>
    <div :class="showAddress ? 'shopingCarShow' : 'shopingCar'">
      <p class="add_title">选择收货地址</p>
      <div class="address_item" v-for="(item, index) in adress" :key="index">
        <div
          class="checkbox_div"
          :class="item.id == checkADD.id ? 'checked_div' : ''"
          @click="checkAddress(item)"
        >
          <div v-if="item.id == checkADD.id" class="checkIn"></div>
        </div>
        <div class="head_con" @click="checkAddress(item)">
          <p class="con_address">{{ item.addressDesc }}</p>
          <p class="con_name">{{ item.contactName }} {{ item.contactPhone }}</p>
        </div>
        <div class="edit_address" @click="editAdress(item)">
          <img src="../../static/image/edits.png" alt="" />
        </div>
      </div>
      <div class="payBtn" @click="addAdress">
        新增收货地址
      </div>
    </div>
    <!-- 支付方式 -->
    <div :class="showCheckPay ? 'checkPayShow' : 'checkPay'">
      <p class="add_title">选择支付方式</p>
      <div
        class="checkPay_item"
        @click="checkPay(1)"
        v-if="shopData.paymentTypes.indexOf('wechat') > -1"
      >
        <div class="checkbox_div">
          <div class="checkIn" v-if="payType === 1"></div>
        </div>
        <div class="payType">微信支付</div>
      </div>
      <div
        class="checkPay_item"
        @click="checkPay(2)"
        v-if="shopData.paymentTypes.indexOf('balance') > -1"
      >
        <div class="checkbox_div">
          <div class="checkIn" v-if="payType === 2"></div>
        </div>
        <div class="payType">余额支付</div>
      </div>
      <div class="payBtn" @click="handlePay">
        立即支付
      </div>
    </div>
    <div class="Ret" @click="clickTab"><span>返回上一页</span></div>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
export default {
  name: "Detail",
  data() {
    return {
      showAddress: false,
      checkADD: {},
      showCheckPay: false,
      payType: 0,
      carInfo: {},
      saleTempInfo: {},
      list: [],
      openID: localStorage.getItem("code"),
      adress: [],
      shopData: JSON.parse(localStorage.getItem("shopList"))[0]
      // shopData: { paymentTypes: ["wechat", "balance"] }
    };
  },
  mounted() {
    this.getData();
    this.getAdress();
    let url = window.location.href.split("#")[0];
    url = encodeURIComponent(url);
    this.Request(
      "api/v1/wechat/jsapi/signature",
      { url, terminalID: localStorage.getItem("payclient") },
      r => {
        if (r.data.code == "20000") {
          const { data } = r;
          wx.config({
            debug: false, // 开启调试模式, 调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.data.appid, // 必填，公众号的唯一标识
            timestamp: data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
            signature: data.data.signature, // 必填，签名
            jsApiList: ["chooseWXPay"]
          });
        } else {
          alert(r.data.msg);
        }
      },
      err => {
        alert(err);
      }
    );
    console.log("mountedssssssssssss");
  },
  computed: {
    totleMoney() {
      console.log(this.saleTempInfo.deliveryCost + this.carInfo.costTotal);
      return (
        Number(
          (this.saleTempInfo.deliveryCost + this.carInfo.costTotal).toFixed(2)
        ) || 0
      );
    }
  },
  methods: {
    clickTab() {
      window.location.href = "/#/Mall";
    },
    getAdress() {
      this.RequestMall(
        "GET",
        `h5/mall/address/all?openID=${this.openID}`,
        {},
        r => {
          this.adress = r.data.data.result;
          this.checkADD = r.data.data.result.find(
            item => item.isDefault === true
          );
        }
      );
    },
    getCarData(id) {
      this.RequestMall(
        "GET",
        `h5/mall/cart/goods/all?saleTempID=${id}&openID=${this.openID}`,
        {
          saleTempID: id,
          openID: this.openID
        },
        res => {
          this.list = res.data.data.result;
          // console.log(res);
        }
      );
    },
    getData() {
      // 商户信息
      this.RequestMall(
        "GET",
        "h5/mall/shop/all",
        {},
        r => {
          // 商品信息
          this.RequestMall(
            "GET",
            `h5/mall/goods/all?shopID=${r.data.data.result[0].id}&openID=${this.openID}`,
            {},
            res => {
              const { cartInfo, goodsList, saleTempInfo } = res.data.data;
              this.carInfo = cartInfo;
              this.getCarData(saleTempInfo.id);
              // this.list = goodsList;
              this.saleTempInfo = saleTempInfo;
            },
            err => console.log(err)
          );
          // console.log(r, "resssssssssss");
        },
        err => {
          console.log(err);
        }
      );
    },
    hidemask() {
      this.showAddress = false;
      this.showCheckPay = false;
    },
    showCheckadd() {
      this.showAddress = true;
    },
    checkAddress(item) {
      this.checkADD = item;
      this.hidemask();
    },
    checkPay(type) {
      this.payType = type;
    },
    handlePay() {
      if (this.payType === 0) {
        Toast("请选择支付方式！");
        return;
      }
      if (!this.checkADD.id) {
        Toast("请选择地址后支付！");
        return;
      }
      Indicator.open();
      this.showCheckPay = false;
      const goodsList = this.list.map(item => {
        return {
          goodsID: item.id,
          goodsName: item.name,
          goodsNumber: (item.cartInfo && item.cartInfo.number) || 0,
          goodsPrice: item.normalPrice,
          goodsImageUrl: item.imgUrl
        };
      });
      // 创建订单
      this.RequestMall(
        "POST",
        `h5/mall/order?shopID=${localStorage.getItem("shopID")}&openID=${
          this.openID
        }&saleTempID=${this.saleTempInfo.id}`,
        {
          companyID: localStorage.getItem("companyID"),
          shopID: localStorage.getItem("shopID"),
          saleTempID: this.saleTempInfo.id,
          openID: this.openID,
          amount: this.totleMoney,
          addressInfo: {
            contactName: this.checkADD.contactName,
            contactPhone: this.checkADD.contactPhone,
            addressDesc: this.checkADD.addressDesc
          },
          type: 1,
          deliveryCost: this.saleTempInfo.deliveryCost,
          deliveryDesc: this.saleTempInfo.deliveryDesc,
          goodsList
        },
        res => {
          const orderID = res.data.data.orderID;
          // 支付
          if (this.payType === 1) {
            this.Request1(
              "v1/payment/prepay",
              {
                providerName: "dejipay",
                payType: "wechat",
                clientType: "mediapress",
                terminalID: localStorage.getItem("payclient"),
                notifyURL:
                  "https://api.cnuri.cn/vip-h5/api/v2/admin/shop/order/notify",
                body: `${localStorage.getItem(
                  "appcode"
                )}|${localStorage.getItem("VIPNO")}`,
                total_fee: this.totleMoney * 100,
                out_trade_no: orderID,
                openID: localStorage.getItem("code")
              },
              r => {
                const { data } = r;
                let that = this;
                // 失败逻辑
                if (data.code !== 0)
                  return alert(data.msg ? data.msg : "请求支付失败");
                const { data: orderInfo } = data;
                // 成功逻辑
                const prepayResult = JSON.parse(orderInfo.raw);
                const { code, data: raw, msg } = prepayResult;
                if (code !== "20000") return alert(msg);
                wx.ready(function() {
                  wx.chooseWXPay({
                    timestamp: raw.timestamp,
                    nonceStr: raw.nonceStr,
                    package: `prepay_id=${raw.prepay_id}`,
                    signType: raw.signType,
                    paySign: raw.paySign,
                    success: function(res) {
                      Indicator.open({
                        text: "支付成功!正在跳转首页...",
                        spinnerType: "fading-circle"
                      });
                      setTimeout(() => {
                        window.location.href = "/#/BindingMenmberCard";
                        Indicator.close();
                      }, 2000);
                    },
                    cancel: function(res) {
                      Indicator.close();
                      alert("已取消支付");
                    },
                    fail: function(res) {}
                  });
                });
              },
              err => {
                console.log(err);
              }
            );
          } else {
            console.log(this.payType);
            const appCode = localStorage.getItem("appcode");
            const cardNo = localStorage.getItem("VIPNO");
            this.RequestMall(
              "POST",
              "h5/mall/order/balancepay",
              {
                amount: this.totleMoney,
                cardNo: cardNo,
                appCode: appCode,
                orderID
              },
              r => {
                if (r.data.code === "20000") {
                  Indicator.close();
                  Indicator.open({
                    text: "支付成功!正在跳转首页...",
                    spinnerType: "fading-circle"
                  });
                  setTimeout(() => {
                    window.location.href = "/#/BindingMenmberCard";
                    Indicator.close();
                  }, 2000);
                } else {
                  Toast("支付失败");
                }
                console.log(r);
              },
              err => {
                Indicator.close();
              }
            );
            // {
            //   amount: amount,
            //   cardNo: VIPNO,
            //   appCode: appcode,
            //   orderID: orderID,
            //   shopID: uni.getStorageSync('lastShop').shopID,
            //   orderNo: DOCNO,
            // }
          }
          console.log(r, "creatorder");
        },
        err => {
          Indicator.close();
        }
      );
      // this.showCheckPay = false;
      // window.location.href = "/#/OrderDetail";
    },
    addAdress() {
      window.location.href = "/#/AddAdress";
    },
    editAdress(item) {
      window.location.href = `/#/AddAdress?value=${JSON.stringify(item)}`;
    }
  }
};
</script>
<style scoped>
.order {
  font-size: 8px;
  width: 100%;
  overflow-x: hidden;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  background: rgba(245, 245, 245, 0.39);
}
.head {
  width: 100%;
  min-height: 61px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 18px;
  border-top: solid 0.5px #757575;
}
.head_img {
  width: 25px;
  height: 25px;
  margin-top: 4px;
}
.head_img img {
  border-radius: 50px;
  width: 100%;
  height: 100%;
}
.head_href {
  height: 25px;
  line-height: 1;
  margin-top: 10px;
}
.head_href img {
  height: 13px;
}
.head_con {
  width: 150px;
}
.con_address {
  font-size: 11px;
  font-weight: 500;
  color: #212121;
}
.con_name {
  font-size: 10px;
  color: #757575;
  margin-top: 4px;
}
.set_con {
  font-size: 11px;
  color: #e0e0e0;
  height: 35px;
  line-height: 35px;
  margin-left: 40px;
}
.goods_list {
  background: #ffffff;
  margin-top: 5px;
}
.list_item {
  width: 100%;
  height: 73px;
  background: white;
  /* border: solid 1px; */
  box-sizing: border-box;
  padding: 11px;
  display: flex;
  position: relative;
  justify-content: flex-start;
}
.item_img {
  width: 50px;
  height: 50px;
}
.item_img img {
  width: 100%;
  height: 100%;
}
.item_center {
  width: calc(100% - 65px);
  overflow: hidden;
  margin-left: 11px;
  margin-top: 10px;
}
.center_tit {
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #757575;
}

.center_price {
  font-size: 11px;
  line-height: 12px;
  color: #fe6262;
  margin-top: 11px;
  position: relative;
}
.center_price span {
  position: absolute;
  right: 0;
  font-size: 8px;
  color: #757575;
}
.list_title {
  font-size: 10px;
  color: #212121;
  padding: 11px 0 0 11px;
}
.distribution {
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  padding: 0 11px;
  height: 25px;
  line-height: 25px;
  display: flex;
  color: #212121;
  font-size: 8px;
  justify-content: space-between;
}
.distribution_tit {
  font-size: 8px;
  color: #757575;
}
.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 39px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: start;
  padding: 6px 11px;
  box-sizing: border-box;
  z-index: 99;
  border-top: solid 1px #e0e0e0;
}
.car {
  /* width: 25px; */
  height: 25px;
  margin-top: 2px;
  position: relative;
}
.jiesuan {
  width: 76px;
  height: 25px;
  background: #fe6262;
  border-radius: 69px;
  line-height: 25px;
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  position: absolute;
  right: 11px;
  top: 6px;
}
.totle {
  font-size: 12px;
}
.totle_money {
  font-size: 14px;
  color: #f2553d;
}
.shopingCar {
  width: 100%;
  position: fixed;
  bottom: -350px;
  left: 0;
  height: 350px;
  background: #ffffff;
  z-index: 999;
  overflow: scroll;
  padding-bottom: 55px;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
}
.shopingCarShow {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 350px;
  background: #ffffff;
  z-index: 999;
  overflow: scroll;
  padding-bottom: 55px;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
}
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.39);
  position: fixed;
  top: 0;
  left: 0;
}
.add_title {
  width: 100%;
  text-align: center;
  color: #212121;
  font-size: 11px;
  padding: 9px 0;
}
.address_item {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px;
  display: flex;
  justify-content: space-between;
}
.checkbox_div {
  width: 11px;
  height: 11px;
  border: 1px solid #bdbdbd;
  border-radius: 50%;
  margin-top: 14px;
}
.checked_div {
  border: 1px solid #fe6262;
}
.checkIn {
  width: 7px;
  height: 7px;
  background: #fe6262;
  border-radius: 50px;
  margin: 2px;
}
.edit_address {
  width: 17px;
  /* height: 15px; */
  margin-top: 10px;
}
.edit_address img {
  width: 100%;
}
.checkPay {
  width: 100%;
  position: fixed;
  bottom: -200px;
  left: 0;
  height: 200px;
  background: #ffffff;
  z-index: 999;
  overflow: scroll;
  padding-bottom: 55px;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
}
.checkPayShow {
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0;
  height: 200px;
  background: #ffffff;
  z-index: 999;
  overflow: scroll;
  /* padding-bottom: 55px; */
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
}
.checkPay_item {
  width: 40%;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
  cursor: pointer;
}
.payBtn {
  width: 80%;
  margin-left: 10%;
  text-align: center;
  color: #ffffff;
  height: 29px;
  line-height: 29px;
  font-size: 11px;
  margin-top: 20px;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
}
.Ret {
  position: fixed;
  z-index: 9;
  bottom: 170px;
  left: 0px;
  width: 24%;
  height: 20px;
  background: #fff;
  line-height: 20px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  color: #212121;
  box-shadow: 0px 0px 0.8px 0px #757575;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/order/index.vue